import vue from './main';
// import NProgress from 'nprogress'; // progress bar
import { Message } from 'iview';
import router from './router';
import store from './store';
import { getStorage, setStorage } from './utils/storage';
import { baseRouterList } from '@/config/router.config';
import 'nprogress/nprogress.css'; // progress bar style
import api from '@/api/user/user';
import api2 from '@/api/Login/forgetPwd';
import { dataToSha, phoneOrPc, setIconTitle } from '@/utils/util';

const { verifyPassword } = api2;
const { getUserRouter, verifySalary, recordingRoute, iconTitle } = api;

// NProgress 配置
// NProgress.configure({ showSpinner: true });

// 白名单
const whiteList = baseRouterList.map(item => item.name);

// 首页四菜单
// const homeMenu = ['/employee-information', '/my-needs', '/my-agent', '/org-rel'];

// 判断是否有checkIsHaveTenantId
const checkIsHaveTenantId = async () => {
  // 首先，判断store中有没有token
  if (store.state.user.tenantId) {
    return true;
  }
  // 其次，如果localStorage里面有tenantId，就获取localStorage中的tenantId，然后赋值给store
  const tenantId = localStorage.getItem('tenantId');
  if (localStorage.getItem('tenantId')) {
    store.commit('user/updateState', {
      tenantId,
    });
    return true;
  }
  return false;
};

// 判断是否有token
const checkIsHaveToken = () => {
  // 首先，判断store中有没有token
  if (store.state.user.access_token) {
    // 用户清楚浏览记录时无法回到客户编号页面问题
    if (!getStorage('access_token')) {
      store.commit('user/updateState', {
        tenantId: '',
      });
    }
    return true;
    // 其次，如果storage里面有token，就获取storage中的token，然后赋值给store
  }
  if (getStorage('access_token')) {
    store.commit('user/updateState', {
      access_token: getStorage('access_token'),
      userInfo: getStorage('userInfo'),
      userApplication: getStorage('userApplication'),
    });
    return true;
  }
  return false;
};
const getMenuId = to => {
  console.log(to);
  const arr = JSON.parse(sessionStorage.getItem('initUserMenu'));
  for (let i = 0; i < arr.length; i++) {
    if (to.meta.id === arr[i].href) {
      const title = {
        title: arr[i].title,
        icon: arr[i].icon,
      };
      sessionStorage.setItem('title', JSON.stringify(title));
      return true;
    }
  }
  sessionStorage.removeItem('title');
  return false;
};
// const recordingRoutes = async (route) => {
//   await recordingRoute(route);
//   return true;
// };
// router进入前的判断
router.beforeEach(async (to, from, next) => {
  // await recordingRoutes(to.path);
  // 使用nprogress进度条
  // NProgress.start();
  // if (to.name === 'custom') {
  // 判断是手机端还是PC端
  // if (to.query.cust) {
  //   sessionStorage.clear()
  //   localStorage.clear();
  // }
  //重新渲染后跳转到目标页面
  if (sessionStorage.toRoute) {
    const toRoute = sessionStorage.toRoute;
    sessionStorage.removeItem('toRoute');
    window.location.href = toRoute;
  }

  if (/(iPhone|iPod|iOS|Android)/i.test(navigator.userAgent)) {
    // 移动端
    let url = phoneOrPc();
    let h5Path = to.fullPath;
    //抄送详情
    if (window.location.pathname === '/cc-detail' && window.location.search) {
      h5Path = window.location.pathname + window.location.search;
    }
    //第三方通知跳转
    if (window.location.pathname === '/third-party' && window.location.search) {
      h5Path = window.location.pathname + window.location.search;
    }
    //入职管理填写
    if (window.location.pathname === '/personnel/entry' && window.location.search) {
      h5Path = '/entry' + window.location.search;
    }
    //h5没有的页面
    if (
      h5Path !== '/time-admin' &&
      h5Path !== '/salary-adjust' &&
      h5Path !== '/okrWorkshop' &&
      h5Path !== '/big-data' &&
      h5Path !== '/personnel' &&
      h5Path !== '/setting'
    )
      window.location.href = url + h5Path;
    else window.location.href = url;
    throw new Error('h5');
  }
  // 判断路由是否正确（是否有name)如果路由错误，则跳转到404
  if (!to.name) {
    next({ name: '404', replace: true });
    // NProgress.done();
    return false;
  }

  //第三方免登录
  if (
    ['noSecret', 'noSecretWeix', 'noSecretFeis', 'scanCodeFeis', 'noSecretWechat'].indexOf(
      to.name
    ) !== -1
  ) {
    let code = to.query.code;
    let tenantId = to.params.key;
    await store
      .dispatch('user/getLoginDing', { code: code, tenantId: tenantId, api: to.name })
      .then(res => {
        if (res) {
          if (to.query.redirecturi) {
            const redirecturi = to.query.redirecturi.replace('/', '?');
            router.replace(redirecturi);
          } else {
            router.replace('/index');
          }
        } else {
          localStorage.removeItem('password');
          router.replace('/login');
        }
      });
    // return false;
  }

  //我的工资扫码验证
  if (to.name === 'noSecretWage') {
    let code = to.query.code;
    let tenantId = localStorage.getItem('tenantId');
    const obj = { code: code, tenantId: tenantId, api: to.params.key };
    localStorage.setItem('no_secret_wage', JSON.stringify(obj));
    next('/salary');
  }

  //跳转第三方网站
  if (to.name === 'recruit') {
    await store.dispatch('user/getrecruitUrl').then(res => {
      if (res && res.data) {
        window.open(res.data);
        return false;
      } else {
        Message.info(
          localStorage.getItem('lang') === 'cn'
            ? '您暂无权限进入此页！'
            : 'You have no access to this page at this time!'
        );
        next('/home');
      }
    });
    return false;
  }

  //跳转魔学院
  if (to.name === 'moxueyuan') {
    await store.dispatch('user/getmoboUrl').then(res => {
      if (res && res.data) {
        window.open(res.data);
        return false;
      } else {
        Message.info(
          localStorage.getItem('lang') === 'cn'
            ? '您暂无权限进入此页！'
            : 'You have no access to this page at this time!'
        );
        next('/home');
      }
    });
    return false;
  }

  // 判断是否有token
  const isHaveToken = checkIsHaveToken();

  //跳转抄送详情
  if (to.name === 'ccDetail') {
    if (to.query.procInstId) {
      sessionStorage.setItem('ccDetail', JSON.stringify(to.query));
    }
  }

  //第三方直接跳转代办详情
  if (to.name === 'thirdParty') {
    if (to.query.procInstId) {
      sessionStorage.setItem('approvalInfo', JSON.stringify({ proc_inst_id: to.query.procInstId }));
      //没有token直接登录
      // if (!isHaveToken && to.query.userId) {
      //   this.$store.dispatch('user/switchToProxy', to.query.userId).then(() => {
      //     sessionStorage.setItem('tenantId', JSON.stringify(to.query.tenantId));
      //   });
      // }
    }
  }

  // 判断是否有tenantId
  const isHaveTenant = await checkIsHaveTenantId();
  if (!isHaveTenant && !to.query.cust && to.name !== 'custom') {
    if (to.name === 'candidate' || to.name === 'visitor') {
      next();
    } else {
      next('/');
      sessionStorage.clear();
      store.commit('user/updateState', {
        access_token: '',
      });
    }
    // NProgress.done();
    return false;
  }

  // 首先判断是否是白名单,如果是白名单,则不判断权限
  if (whiteList.indexOf(to.name) > -1) {
    // 如果目标是客户编号页面，则判断是否有tenantId
    // 如果有tenantId,则跳转到登录页
    if (to.name === 'custom') {
      if (to.query.cust) {
        store.dispatch('user/validateTenantId', to.query.cust).then(res => {
          if (res) {
            store.commit('user/updateState', {
              tenantId: to.query.cust,
            });
            next('/login');
            return false;
            // NProgress.done();
          }
          next('');
          return false;
        });
      } else if (isHaveTenant) {
        next('/login');
        // NProgress.done();
        return false;
      }
      next();
      return false;
    }
    // 如果目标是登录页，则判断是否有token
    if (to.name === 'login' && isHaveToken) {
      // NProgress.done();
      next('/home');
      return false;
    }
    next();
    return false;
  }
  // 如果有token
  if (isHaveToken) {
    // 正常情况
    // 判断用户是否拥有即将跳转路由地址权限
    // menu_id为0的路由属于无需权限控制路由
    if (to.path === '/salary') {
      //我的工资扫码验证
      let secretObj = localStorage.getItem('no_secret_wage');
      if (secretObj) {
        localStorage.removeItem('no_secret_wage');
        secretObj = JSON.parse(secretObj);
        const res = await api[secretObj.api](secretObj);
        if (res) {
          next();
          return true;
        } else {
          next('/home');
          return false;
        }
      }
      getMenuId(to);
      const res = await verifySalary(0); // to.meta.id
      if (res && res.data) {
        vue.$verifyPassword.info({
          onOk: async val => {
            const resCode = await verifyPassword({
              user_name: sessionStorage.userInfo
                ? JSON.parse(sessionStorage.userInfo).user_name
                : undefined,
              pwd: dataToSha(val.password),
            });
            if (resCode) {
              next();
              return true;
            }
            return false;
          },
          onCancel: () => {
            next(from.path);
            // NProgress.done();
            return false;
          },
        });
      } else if (res) {
        next();
      }
      // NProgress.done();
      return false;
    }

    if (to.path === '/enterprise-brain') {
      const tenantId = store.state.user.tenantId || localStorage.getItem('tenantId');
      if (tenantId === 'liljas') {
        next('/liljas-brain');
        return false;
      }
    }

    if (to.meta.id && to.meta.id !== 0) {
      if (!getMenuId(to) && to.path !== '/home') {
        Message.info(
          localStorage.getItem('lang') === 'cn'
            ? '您暂无权限进入此页！'
            : 'You have no access to this page at this time!'
        );
        next('/home');
        // NProgress.done();
        return false;
      }
    }
    next();
    // NProgress.done();
    return false;
  }
  // 保存当前路由name以在登录之后直接调转到此路由
  sessionStorage.setItem('toUrl', window.location.href);
  // 如果没有token则跳转到登录
  next('/login');
  // NProgress.done();
  return false;
});

// // router进入后的动作
// router.afterEach(() => {
//   // NProgress.done();
//   sessionStorage.removeItem('toRoute')
// });

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError(error => {
  const pattern = /Loading chunk (.+) failed/;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    //记录需要跳转到的页面
    sessionStorage.toRoute = targetPath;
    window.location.reload(true);
  }
});
